export const MINIMUM_LOCATION_AREA_POINTS = 3;
export const MAXIMUM_LOCATION_AREA_POINTS = 20;
export const MAXIMUM_LOCATION_AREAS = 10;
export const HIGHEST_LOCATION_ZINDEX = MAXIMUM_LOCATION_AREAS * 2 + 1;
